import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LoadingState } from '@components';

// Lazy load team view components
const TeamMarketingAssets = lazy(() => import('./MarketingAssets').then((module) => ({ default: module.TeamMarketingAssets })));
const TeamProductionOverviewDetail = lazy(() =>
  import('./ProductionOverviewDetail/TeamProductionOverviewDetail').then((m) => ({ default: m.TeamProductionOverviewDetail })),
);
const AdvisorProductionOverviewDetail = lazy(() =>
  import('./ProductionOverviewDetail/AdvisorProductionOverviewDetail').then((m) => ({ default: m.AdvisorProductionOverviewDetail })),
);

export const TeamViewRouter = () => (
  <Suspense fallback={<LoadingState />}>
    <Routes>
      <Route path={`marketing-assets`} element={<TeamMarketingAssets />} />
      <Route path={`deals`} element={<TeamProductionOverviewDetail />} />
      <Route path={`advisor/deals`} element={<AdvisorProductionOverviewDetail />} />
    </Routes>
  </Suspense>
);

export default TeamViewRouter;
